import { Component, inject } from '@angular/core';
import { FundamentalProcessService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FundamentalProcessCreateDto,
  FundamentalProcessDto,
  FundamentalProcessExcelDownloadDto,
  FundamentalProcessUpdateDto,
} from '../proxy/general/dtos/fundamental-process';
import { FUNDAMENTALPROCESS_CONFIG, FUNDAMENTALPROCESS_FIELDS } from './fundamental-process.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-fundamental-process',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FundamentalProcessService, ConfirmationService],
  templateUrl: './fundamental-process.html',
  styleUrl: './fundamental-process.scss',
})
export class FundamentalProcess extends BaseCrudComponent<
  FundamentalProcessDto,
  FundamentalProcessCreateDto,
  FundamentalProcessUpdateDto,
  FundamentalProcessExcelDownloadDto
> {
  service = inject(FundamentalProcessService);
  config = FUNDAMENTALPROCESS_CONFIG;
  fields = FUNDAMENTALPROCESS_FIELDS;

  protected prepareUpdateDto(data: any, selected: FundamentalProcessDto): FundamentalProcessUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FundamentalProcess';
  }
}
